import $ from "jquery";
import util from "../util";
import MenuObject from "./menu-object";
import History from "./history";
import constants from "../constants";
import store from "../store";
import {getElementsPositions} from "./position";
import {deselect} from "./selection";
import {ensureFrameDimensions} from "./dimension";
import { isElementOffPage } from "./component";
import Cleaner from "./cleaner";
import { removePageBars } from "./selection";
import Interactable from "./interactable";

export function regroup($group, cfg = {}) {
    const groupId = $group.attr('id');
    const $kids = [];

    $group.children('[data-component]').each(function () {
        $kids.push($(this));
    });

    ungroup($group, { history: false });
    group($kids, {
        regroup: true,
        history: false,
        reselect: cfg.reselect,
        groupId
    });
}

export function  ungroup($group, cfg) {
    cfg = cfg || {};
    cfg.history = cfg.history === undefined ? true : cfg.history;

    if ($group.attr('data-component') !== 'group') {
        $group = $group.parents('.group');
    }

    const pageWidth = util.getActiveDimensions().width;
    const pageHeight = util.getActiveDimensions().height;

    const gpTop = parseFloat($group.css('top'));
    const gpLeft = parseFloat($group.css('left'));

    const interactableGroup = Interactable.of($group);

    $group.children().each(function () {
        const $element = $(this);
        let elTop = parseFloat($element.css('top'));
        let elLeft = parseFloat($element.css('left'));
        if ($element.css('position') !== 'absolute') {
            const position = $element.position();
            elTop = position.top;
            elLeft = position.left;
        }

        $element.css('top', `${util.pixelToPercent(elTop + gpTop, pageHeight)}%`);
        $element.css('left', `${util.pixelToPercent(elLeft + gpLeft, pageWidth)}%`);

        $element.removeAttr('data-in-group');

        const newWidth = `${util.pixelToPercent($element.width(), pageWidth)}%`;
        const newHeight = `${util.pixelToPercent($element.height(), pageHeight)}%`;

        $element.css('width', newWidth);
        if (MenuObject.isMenuObject($element)) {
            $element.css('height', 'auto');
        } else {
            $element.css('height', newHeight);
        }

        const interactableElement = Interactable.of($element);

        interactableElement.setTranslateX(interactableElement.getTranslateX() + interactableGroup.getTranslateX());
        interactableElement.setTranslateY(interactableElement.getTranslateY() + interactableGroup.getTranslateY());
        interactableElement.refreshPosition();
        Interactable.destroy(interactableElement);
    });

    const $pageContent = $group.parent();
    const $elements = [];
    $group.children().each(function () { $elements.push($(this)) });

    function redo() {
        $group.children().each(function () {
            const $element = $(this);
            if ($element.hasClass('bars')) {
                $element.remove();
            } else {
                $element.css('position', 'absolute');
                $element.css('display', 'inline-block');
                $element.addClass('move');
                $element.appendTo($pageContent);
            }

            if (isElementOffPage($element)) {
                Cleaner.removeElement($element);
            }
        })

        removePageBars($group);
        Interactable.destroy(interactableGroup);
    }

    function undo() {
        group($elements)
    }

    redo();
    if (cfg.history) {
        History.push(undo, redo, 'Ungroup');
    }

    $group.remove();
}

export function group($elements, cfg = {}) {
    let $group = null;
    cfg.history = cfg.history === undefined ? true : cfg.history;
    cfg.reselect = cfg.reselect === undefined ? true : cfg.reselect;

    const doAction = () => {
        const pageWidth = util.getActiveDimensions().width;
        const pageHeight = util.getActiveDimensions().height;

        const result = getElementsPositions($elements);

        let { isExistingGroup, top, left, bottom, right } = result;

        $elements.forEach(($element) => {
            const parentBoundingRect = $element.parent().get(0).getBoundingClientRect();

            const elementBoundingRect = $element.get(0).getBoundingClientRect();
            const elTop = elementBoundingRect.top - parentBoundingRect.top;
            const elLeft = elementBoundingRect.left - parentBoundingRect.left;
            const { width, height } = elementBoundingRect;

            if (top > elTop) top = elTop;
            if (left > elLeft) left = elLeft;

            if (bottom < elTop + height) bottom = elTop + height;
            if (right < elLeft + width) right = elLeft + width;

            if ($element.parents('.group').length > 0) {
                isExistingGroup = true
            }
        });

        if (isExistingGroup) return;

        if (constants.SCALED_ZOOM_APPROACH) {
            const zoom = store.getState().zoom/100;
            if (zoom < 1) {
                left = left/zoom;
                top = top/zoom;
            }
            if (zoom > 1){
                right = right/zoom;
                bottom = bottom/zoom;
            }
        }

        if (cfg.regroup !== true) {
            left -= constants.GROUP_ASIDE_SPACE_BUFFER;
            right += constants.GROUP_ASIDE_SPACE_BUFFER;
        }

        const percentLeft = util.pixelToPercent(left, pageWidth);
        const percentTop = util.pixelToPercent(top, pageHeight);
        const percentWidth = util.pixelToPercent(right - left, pageWidth);
        const percentHeight = util.pixelToPercent(bottom - top, pageHeight);
        const newGroupId = cfg.groupId || util.UUID.get();

        $group = $(
          '<div data-component="group" class="group select move" '
          + `id="${newGroupId}" `
          + `data-x="${left}" data-y="${top}" `
          + `data-original-left="${left}" data-original-top="${top}" `
          + `style="position: absolute; left: ${percentLeft}%; top: ${percentTop}%; width: ${percentWidth}%; height: ${percentHeight}%">`
          + '</div>'
        );

        if (cfg.top) {
            $group.css('top', cfg.top);
        }

        $elements[0].parent().append($group);

        const groupWidth = $group.width();
        const groupHeight = $group.height();

        $elements.forEach(($element) => {
            const elTop = parseFloat($element.css('top'));
            const elLeft = parseFloat($element.css('left'));

            const elPercentTop = util.pixelToPercent(elTop - top, groupHeight);
            const elPercentLeft = util.pixelToPercent(elLeft - left, groupWidth);

            $element.css('top', `${elPercentTop}%`);
            $element.css('left', `${elPercentLeft}%`);

            $element.attr('data-top-in-group', elTop - top);

            const elHeight = $element.height();
            $element.attr('data-height-in-group', elHeight);

            $element.removeClass('move');
            deselect($element);

            if (util.isFrame($element)) {
                ensureFrameDimensions($element, groupHeight);
            } else if (util.isImage($element) || util.isShape($element)) {
                $element.css('height', '');
            } else {
                $element.css('height', `${util.pixelToPercent($element.height(), groupHeight)}%`);
            }
            const buffer = (cfg.regroup !== true) ? constants.GROUP_WIDTH_BUFFER : 0;
            $element.css('width', `${util.pixelToPercent($element.width() + buffer, groupWidth)}%`);

            $element.appendTo($group);
            $element.attr('data-in-group', 'true');

            Interactable.destroy(Interactable.of($element));
        });

        setIndexInGroup($elements);

        if (cfg.reselect) {
            $group.click();
        }
    };

    const redo = () => doAction();
    const undo = () => {
        ungroup(util.getGroup($elements[0]), { history: false });
    };

    redo();
    if (cfg.history) {
        History.push(undo, redo, 'Group');
    }
}

export function setIndexInGroup($elements) {
    const topsInGroup = [];
    let $ems = [];

    if ($elements.each) {
        $elements.each(function () { $ems.push($(this)) });
    } else {
        $ems = $elements;
    }

    $ems.forEach(($element) => {
        const idx = parseInt($element.attr('data-top-in-group'), 10);
        topsInGroup.push(parseInt(idx / 10, 10));
    });

    topsInGroup.sort((a, b) => a - b);

    $ems.forEach(($element) => {
        const idx = parseInt($element.attr('data-top-in-group'), 10);
        $element.attr('data-idx-in-group', topsInGroup.indexOf(parseInt(idx / 10, 10)));
    });
}

export function ensureGroupSize($group, width, height) {
    let top = Number.MAX_SAFE_INTEGER;
    let left = Number.MAX_SAFE_INTEGER;
    let bottom = 0;
    let right = 0;

    if (!width || !height) {
        $group.children().each(function () {
            const $this = $(this);
            const position = $this.position()
            if (position.top < top) top = position.top;
            if (position.left < left) left = position.left;

            const candidateBottom = position.top + $this.height();
            if (candidateBottom > bottom) bottom = candidateBottom;

            const candidateRight = position.left + $this.width();
            if (candidateRight > right) {
                right = candidateRight;
            }
        });
        width = right - left;
        height = bottom - top;
    }

    $group.css('width', `${util.pixelToPercent(width, util.getActiveDimensions().width)}%`);
    $group.css('height', `${util.pixelToPercent(height, util.getActiveDimensions().height)}%`);
}
